// @flow
const tableHead = {
	textAlign: 'center',
	backgroundColor: 'text.dark',
	color: 'common.white',
};

const tableRow = {
	'&:nth-of-type(odd)': {
		backgroundColor: 'action.hover',
	},
	'&:nth-of-type(even)': {
		backgroundColor: 'secondary.light',
	},
	'&:last-child td, &:last-child th': {
		border: 0,
	},
	'& td': {
		textAlign: 'center',
	},
};

const collapsibleTableHead = {
	textAlign: 'center',
	backgroundColor: 'text.light',
	color: 'common.white',
};

const collapsibleTableRow = {
	'&:nth-of-type(odd)': {
		backgroundColor: 'action.hover',
	},
	'&:nth-of-type(even)': {
		backgroundColor: 'secondary.light',
	},
	'& td': {
		textAlign: 'center',
	},
};

export { tableHead, tableRow, collapsibleTableHead, collapsibleTableRow };